module.exports = __webpack_public_path__ + "assets/Terrorism.cc33cca5.svg";